import { render, staticRenderFns } from "./BlujayChainIndex.vue?vue&type=template&id=ee84b9e4&scoped=true&"
import script from "./BlujayChainIndex.vue?vue&type=script&lang=js&"
export * from "./BlujayChainIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlujayChainIndex.vue?vue&type=style&index=0&id=ee84b9e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee84b9e4",
  null
  
)

export default component.exports